// extracted by mini-css-extract-plugin
export default {"root":"PageCounter_root__hzZva","counter":"PageCounter_counter__tDaqc"};